import { Component, inject, Input } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'sd-dialog',
  standalone: false,
  templateUrl: './sd-dialog.component.html',
  styleUrl: './sd-dialog.component.scss'
})
export class SdDialogComponent {
  @Input() title = '';
  
  private matDialog = inject(MatDialogRef<any>);

  close() {
    this.matDialog.close();
  }
}
